import React from 'react';
import {AlertTriangle, CheckCircle2, Circle} from 'lucide-react';
import {readinessPaymentButton} from './ReadinessPresentation';

const labels={not_sent:'Not sent',queued:'Queued to send',sent:'Already sent',completed:'Completed — view below',
    requires_attention:'Needs review',incomplete:'Still needed for some treatments',send_failed:'Send failed'};

export function VisitReadinessForms({forms, busy, onSend, onReview}) {
    return <ul className="divide-y divide-white/5" aria-label="Treatment forms">
        {forms.map(form=>{
            const aftercare=String(form.kind || '').startsWith('aftercare');
            const attention=form.status==='requires_attention';
            const done=form.status==='completed'||(aftercare&&form.status==='sent');
            return <li key={form.template_id} className="py-2.5 space-y-2">
                <div className="flex flex-wrap items-center gap-3">
                    <div className={`h-8 w-8 rounded-full grid place-items-center shrink-0 ${attention?'bg-amber-500/15 text-amber-200':done?'bg-emerald-500/15 text-emerald-200':'bg-white/5 text-white/40'}`}>
                        {attention?<AlertTriangle className="h-4 w-4"/>:done?<CheckCircle2 className="h-4 w-4"/>:<Circle className="h-4 w-4"/>}
                    </div>
                    <div className="flex-1 min-w-[120px]">
                        <h3 className="text-sm text-white break-words">{form.name}</h3>
                        <p className="text-[11px] text-white/60">{labels[form.status]||form.status}</p>
                        <p className="text-[11px] text-white/50 break-words">{form.treatment_names.join(' · ')}</p>
                        {aftercare&&<p className="text-[11px] text-white/50">{form.delivery_triggers.includes('checkout')?'Sent at checkout':'Aftercare'}</p>}
                    </div>
                    {!done&&!attention&&<button type="button" className={readinessPaymentButton} disabled={busy||form.status==='queued'} onClick={()=>onSend(form)}>
                        {form.status==='queued'?'Queued':form.status==='sent'?'Send again':'Send form'}
                    </button>}
                </div>
                {attention&&<div className="rounded-xl border border-amber-400/50 bg-amber-500/10 p-3 text-amber-100 text-sm">
                    <div className="font-medium">Requires attention — review the completed form below</div>
                    <ul className="list-disc list-inside text-xs">{(form.attention_flags||[]).map((flag,i)=><li key={i}>{flag}</li>)}</ul>
                    {(form.review_dispatches||[]).length>0&&<button type="button" disabled={busy} className="mt-2 rounded-full border border-emerald-400/50 px-3 py-2 text-xs" onClick={()=>onReview(form)}>Mark reviewed</button>}
                </div>}
            </li>;
        })}
    </ul>;
}
